<template>
  <v-card elevation="0">
    <template v-if="!error && !!lastUpdate && firstLoad">
      <div class="mt-2 px-2 d-flex align-center">
        <!-- <v-btn
          @click="goToFinancial"
          text
          x-small
          color="primary"
          v-if="hasPermission(2048)"
        >
          Ver financeiro completo
          <v-icon x-small right>mdi-open-in-new</v-icon>
        </v-btn> -->
        <!-- <Filters
          v-model="filter"
          class="pr-2"
          :party="party"
          :sellers="sellers"
          :pos-sellers="posSellers"
          :ticket-groups="ticketGroups"
          :sale-links="saleLinks"
        /> -->
        <!-- <v-btn
          color="primary"
          depressed
          small
          text
          :to="`/admin/organization/entrance/${partyId}/management`"
        >
          Ver Entradas
        </v-btn> -->
        <v-spacer />
        <v-btn depressed x-small :disabled="loading" @click="openExport">
          Exportar
          <v-icon right x-small>mdi-file-export</v-icon>
        </v-btn>
        <v-btn
          @click="$emit('refresh')"
          icon
          small
          :loading="loading"
          :disabled="blockRefresh"
          :class="loading ? 'mr-2' : ''"
        >
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
        <span class="text-caption" v-if="lastUpdate">
          Última atualização: {{ lastUpdate | date("DD/MM [às] HH:mm:ss") }}
        </span>
      </div>

      <div v-if="party.ChildParties.length">
        <v-chip-group v-model="filterSubParties" color="primary" show-arrows>
          <v-chip small filter :value="null"> Todos </v-chip>
          <v-chip :value="party.id" filter small> Principal </v-chip>
          <v-chip
            v-for="subParty in party.ChildParties"
            :key="subParty.id"
            :value="subParty.id"
            filter
            small
          >
            {{ subParty.name }}
          </v-chip>
        </v-chip-group>
      </div>

      <v-alert
        v-if="loading && isOldData"
        class="mb-2 mx-2"
        icon="mdi-update"
        type="warning"
        text
      >
        Os dados estão {{ [lastUpdate] | dateDiff }} desatualizados. Por favor
        aguarde enquanto buscamos os dados mais recentes.
      </v-alert>

      <div class="pa-2">
        <highlights :data="{ party, ...filterReportData }" :loading="loading" />
      </div>

      <v-alert
        v-if="hiddenTicketBlocks.size"
        :type="showHiddenTicketblocks ? 'success' : 'warning'"
        class="mb-2 mx-2"
        dense
        text
      >
        <div class="d-flex align-center justify-space-between">
          <template v-if="showHiddenTicketblocks">
            Todos os lotes estão habilitados no relatório.
          </template>
          <template v-else>
            {{ hiddenTicketBlocks.size }} lotes estão desabilitados no
            relatório.
          </template>
          <v-btn
            v-if="!showHiddenTicketblocks"
            small
            @click="showHiddenLots"
            class="ml-2"
          >
            Mostrar lotes desabilitados
          </v-btn>
          <v-btn
            v-else
            small
            class="ml-2"
            @click="showHiddenTicketblocks = false"
          >
            Ocultar lotes desabilitados
          </v-btn>
        </div>
      </v-alert>

      <cols-organizer md="2" xl="3" :items="computedReports">
        <template v-slot="{ item }">
          <component
            :is="item"
            :id="item"
            :loading="loading"
            :data="{ party, ticketGroups, ...filterReportData }"
          />
        </template>
      </cols-organizer>
    </template>
    <v-alert v-else-if="error" type="error" class="mb-0">
      <v-row align="center">
        <v-col class="grow py-0">
          {{ error }}
        </v-col>
        <v-col class="shrink py-0">
          <v-btn small @click="$emit('refresh')" :disabled="blockRefresh">
            Tentar novamente
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <template v-else>
      <v-progress-linear indeterminate color="info" class="mt-2" />
      <v-alert type="info" text class="mt-0 mb-0">
        Carregando relatório, por favor aguarde...
        <p v-if="oldEvent" class="mb-0">
          Eventos antigos podem demorar mais para carregar
        </p>
      </v-alert>
    </template>

    <party-report-show-hidden-ticketblocks
      ref="showHiddenTicketblocksModal"
      :hiddenTicketBlocks="hiddenTicketBlocks"
      :ticketBlocks="ticketBlockMap"
    />

    <export-modal
      :ticketGroups="ticketGroups"
      :posSellers="posSellers"
      :party="party"
      :sellers="sellers"
      :saleLinks="saleLinks"
      :reportData="{
        tickets: this.filterTickets,
        payments: this.filterPayments,
      }"
    />
  </v-card>
</template>

<script>
import moment from "moment";

import ExportModal from "./reports/export/ExportModal.vue";
import SalesFromToday from "./reports/SalesFromToday.vue";
import SalesByDay from "./reports/SalesByDay.vue";
import SalesEvolution from "./reports/SalesEvolution.vue";
import SalesByTicketBlock from "./reports/SalesByTicketBlock.vue";
import SalesBySeller from "./reports/SalesBySeller.vue";
import SalesByPaymentType from "./reports/SalesByPaymentType.vue";
import SalesByChannel from "./reports/SalesByChannel.vue";
import RefundedSales from "./reports/RefundedSales.vue";
import PosSales from "./reports/PosSales.vue";
import TicketOfficeSales from "./reports/TicketOfficeSales.vue";
import CourtesySales from "./reports/CourtesySales.vue";
import TableReport from "./reports/TableReport.vue";
import SalesInCalendar from "./reports/SalesInCalendar.vue";
import SalesForMemberships from "./reports/SalesForMemberships.vue";
import SalesPatten from "./reports/SalesPatten.vue";
import ColsOrganizer from "../../global/ColsOrganizer.vue";
import Highlights from "./reports/Highlights.vue";
import TicketGroupRepresentation from "./reports/TicketGroupRepresentation.vue";
// import Filters from "./reports/Filters.vue";
import PartyReportShowHiddenTicketblocks from "./PartyReportShowHiddenTicketblocks.vue";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    filter: {
      courtesy: true,
    },
    filterSubParties: null,
    showHiddenTicketblocks: false,
    reports: {
      sales_from_today: function () {
        return this.partyActive;
      },
      sales_patten: true,
      sales_in_calendar: true,
      sales_by_ticket_block: true,
      sales_by_payment_type: true,
      // sales_for_memberships: function ({ tickets }) {
      //   return (
      //     this.hasPermission([16, 4194304, 8388608]) &&
      //     tickets.some((t) => !!t.Payment.MembershipFiliation)
      //   );
      // },
      table_report: function ({ tickets }) {
        return tickets.some((t) => !!t.Table);
      },
      pos_sales: true,
      ticket_office_sales: true,
      sales_by_channel: true,
      sales_by_seller: true,
      courtesy_sales: true,
      ticket_group_representation: true,
      refunded_sales: true,
      // sales_evolution: true,
      sales_by_day: true,
    },
  }),

  methods: {
    goToFinancial() {
      this.$router.push({
        name: "admin.transactions.party",
        params: { partyId: this.party.id },
      });
    },
    openExport() {
      this.$root.$emit("exportReport");
    },
    async showHiddenLots() {
      this.showHiddenTicketblocks =
        await this.$refs.showHiddenTicketblocksModal.open();
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    isOldData() {
      this.refreshKey;
      return (
        this.lastUpdate &&
        moment(this.lastUpdate).isBefore(moment().subtract(5, "minutes"))
      );
    },
    partyActive() {
      return moment(this.party?.endDate).isAfter(moment());
    },
    oldEvent() {
      return moment(this.party.date).isBefore(moment().subtract(3, "months"));
    },
    hiddenTicketBlocks() {
      this.refreshKey;
      return this.ticketGroups.reduce((acc, tg) => {
        tg.TicketBlock.forEach((tb) => {
          if (tb.hideInReport) acc.set(tb.id, tb);
        });
        return acc;
      }, new Map());
    },

    filterReportData() {
      this.refreshKey;
      return {
        tickets: this.filterTickets,
        payments: this.filterPayments,
        filter: this.filter,
        raw: this.rawDataSubEventFilter,
      };
    },
    rawDataSubEventFilter() {
      this.refreshKey;

      return {
        payments: this.payments.reduce((acc, p) => {
          const tickets = p.Ticket.filter((t) => {
            if (
              this.filterSubParties &&
              t?.TicketBlock?.TicketGroup?.partytId !== this.filterSubParties
            )
              return false;

            if (
              !this.showHiddenTicketblocks &&
              this.hiddenTicketBlocks.has(t?.TicketBlock?.id)
            )
              return false;

            return true;
          });
          if (tickets.length) acc.push({ ...p, Ticket: tickets });
          return acc;
        }, []),
        tickets: this.tickets.filter((t) => {
          if (
            this.filterSubParties &&
            t?.TicketBlock?.TicketGroup?.partytId !== this.filterSubParties
          )
            return false;

          if (
            !this.showHiddenTicketblocks &&
            this.hiddenTicketBlocks.has(t?.TicketBlock?.id)
          )
            return false;

          return true;
        }),
      };
    },
    partyId() {
      return this.$route.params.partyId;
    },
    filterPayments() {
      this.refreshKey;
      return this.rawDataSubEventFilter.payments.filter((p) => {
        if (!this.filter.courtesy && p.paymentType === "COURTESY") return false;

        const sellerType = p.PosSession
          ? "pos"
          : p.Ticket[0].Seller?.id
          ? "user"
          : "online";

        const sellerId = p.PosSession?.id || p.Ticket[0].Seller?.id || "online";
        if (
          this.filter?.seller?.length &&
          !this.filter.seller.some(
            (s) => s.id === sellerId && s.type === sellerType
          )
        )
          return false;
        return true;
      });
    },
    filterTickets() {
      this.refreshKey;
      return this.filterPayments
        .map(({ Ticket, ...p }) => Ticket.map((t) => ({ ...t, Payment: p })))
        .flat();
    },
    computedReports() {
      this.refreshKey;
      if (!this.filterReportData.payments || !this.filterReportData.tickets)
        return [];
      return Object.keys(this.reports).filter((r) => {
        if (typeof this.reports[r] === "function")
          return this.reports[r].bind(this)(this.rawDataSubEventFilter);
        return this.reports[r];
      });
    },
  },

  components: {
    sales_from_today: SalesFromToday,
    sales_by_day: SalesByDay,
    sales_by_ticket_block: SalesByTicketBlock,
    sales_by_seller: SalesBySeller,
    sales_by_payment_type: SalesByPaymentType,
    sales_in_calendar: SalesInCalendar,
    sales_by_channel: SalesByChannel,
    refunded_sales: RefundedSales,
    sales_patten: SalesPatten,
    pos_sales: PosSales,
    ticket_office_sales: TicketOfficeSales,
    sales_evolution: SalesEvolution,
    courtesy_sales: CourtesySales,
    table_report: TableReport,
    sales_for_memberships: SalesForMemberships,
    ticket_group_representation: TicketGroupRepresentation,
    ColsOrganizer,
    Highlights,
    // Filters,
    ExportModal,
    PartyReportShowHiddenTicketblocks,
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String | Boolean | null,
      default: false,
    },
    lastUpdate: {
      type: Date,
      default: null,
    },
    blockRefresh: {
      type: Boolean,
      default: false,
    },
    refreshKey: {
      type: Number,
      default: 0,
    },
    tickets: {
      type: Array,
      default: () => [],
    },
    payments: {
      type: Array,
      default: () => [],
    },
    ticketGroups: {
      type: Array,
      default: () => [],
    },
    posSellers: {
      type: Array,
      default: () => [],
    },
    saleLinks: {
      type: Array,
      default: () => [],
    },
    sellers: {
      type: Array,
      default: () => [],
    },
    ticketBlockMap: {
      type: Map,
      default: () => new Map(),
    },
    firstLoad: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
